import clsx from "clsx";
import React from "react";
import { CatalogItem } from "types";
import { getDefaultPhotoUrl } from "../../models/CatalogItem";
import { Image, ImageSizes } from "./ProductImage";

export interface CatalogItemImageProps {
    catalogItem: CatalogItem;
    size?: keyof typeof ImageSizes;
    className?: string;
    classNames?: { image?: string; container?: string };
    style?: any;
}

export const CatalogItemImage = ({
    catalogItem,
    size = "medium",
    className,
    classNames,
    ...rest
}: CatalogItemImageProps) => {
    const imageClassName = clsx(
        "border object-fill rounded",
        "!border-gray-light",
        ImageSizes[size],
        classNames?.image ?? "",
    );

    return (
        <div
            className={clsx("ui-product-image mr-3 flex-shrink-0 rounded border-[3px] border-transparent", className)}
            {...rest}
        >
            <AddOnImage className={imageClassName} catalogItem={catalogItem} size={size} />
        </div>
    );
};

export interface AddOnImageProps {
    catalogItem: CatalogItem;
    className: string;
    size?: keyof typeof ImageSizes;
}

const AddOnImage = ({ catalogItem, size, className }: AddOnImageProps) => {
    let xolaSize; // Xola API doesn't support "tiny" or "huge" or "giant"
    switch (size) {
        case "tiny":
            xolaSize = "small";
            break;
        case "huge":
        case "giant":
            xolaSize = "large";
            break;
        default:
            xolaSize = size;
    }

    xolaSize = `${xolaSize}_square`; // we use square images in this app
    const imageSource = getDefaultPhotoUrl(catalogItem, xolaSize);

    return (
        <Image
            data-product-id={catalogItem?.id}
            src={imageSource}
            alt={catalogItem?.name?.trim() ?? "AddOn Image"}
            className={className}
        />
    );
};
